export default "__VITE_ASSET__BAc9FdhW__"